import store from "../store/store";

// Added to the sign-out confirmation when the open guide has changes that
// aren't saved (4.10.55, 2026-10-26): signing out opens the sample guide, so
// they'd be lost. "Unsaved" = a guide never saved that has places, or a saved
// one flagged after a big change (GuideHasUnsavedChanges).
// Also used before opening another guide from the Library (4.11.55).
export const hasUnsavedChanges = (state = store.getState(), guide = window.guide_obj) => {
  const places = guide?.places?.placesList?.length || 0;
  const neverSaved = state.guide_meta?.guide_info_id == null && places > 0;
  return neverSaved || state.GuideHasUnsavedChanges === true;
};

const signOutWarning = () => {
  if (!hasUnsavedChanges()) return "";
  const name = window.guide_obj?.attributes?.guide_name || "this guide";
  return ` "${name}" has changes that aren't saved — they'll be lost. Cancel and Save first to keep them.`;
};

export default signOutWarning;
